<template>
  <div class="layout">
    <div class="top">
      <div class="top_navbar">
        <div>{{ baseInfo.promotionSlogan }}</div>
      </div>
      <img src="@/assets/line.png" class="line">
      <navbar :logo="baseInfo.logo" :site-name="baseInfo.siteName"></navbar>
    </div>
    <div class="min_container">
      <app-main />
      <div class="footer_box">
        <app-footer :base-info="baseInfo"></app-footer>
      </div>
    </div>
  </div>
</template>

<script>
import { AppFooter, AppMain } from './components'
import { getBaseInfo } from '@/api/base'
import Cookies from "js-cookie";

export default {
  name: 'Layout',
  components: {
    AppFooter,
    AppMain
  },
  data () {
    return {
      baseInfo: {
        id: '',
        link: '',
        loginBg: '',
        logo: '',
        mainBg: '',
        phone: '',
        promotionSlogan: '',
        recordNumber: '',
        siteName: '',
        startTime: '',
        endTime: '',
        copyrightNotice: ''
      }
    }
  },
  mounted () {
    this.getBaseInfo()
  },
  methods: {
    getBaseInfo () {
      getBaseInfo().then(res => {
        if (res && res.code == 200) {
          this.baseInfo = res.data
          if (this.baseInfo && this.baseInfo.siteName) {
            Cookies.set('siteName', this.baseInfo.siteName)
            Cookies.set('logo', this.baseInfo.logo)
            if (this.baseInfo.loginBg) {
              Cookies.set('loginBg', this.baseInfo.loginBg)
            } else {
              Cookies.remove('loginBg')
            }
            if (this.baseInfo.mainBg) {
              Cookies.set('mainBg', this.baseInfo.mainBg)
            } else {
              Cookies.remove('mainBg')
            }
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.top_navbar {
  height: 56px;
  display: flex;
  align-items: center;
  background-color: #FFFFFF;
  color: #2A89E2;
  font-size: 30px;
  padding: 14px 40px;
}

.min_container {
  flex: 1;
  overflow-y: scroll;
}
.footer_box{
  padding-top: 72px;
}
.line {
  width: 100%;
  height: 4px;
}
</style>
